import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	title: {
		id: 'project-settings-product-features-jsm-common.form-card.remove-form-confirmation.title',
		defaultMessage: 'Remove form from this request type',
		description:
			'Title of the confirmation dialog when user removes form from the request type configuration.',
	},
	description: {
		id: 'project-settings-product-features-jsm-common.form-card.remove-form-confirmation.description',
		defaultMessage:
			"Existing issues created using this request type won't be affected by this change.",
		description:
			'Description of the confirmation dialog when user removes form from the request type configuration.',
	},
	descriptionIssueTermRefresh: {
		id: 'project-settings-product-features-jsm-common.form-card.remove-form-confirmation.description-issue-term-refresh',
		defaultMessage:
			"Existing work items created using this request type won't be affected by this change.",
		description:
			'Description of the confirmation dialog when user removes form from the request type configuration.',
	},
	cancelButton: {
		id: 'project-settings-product-features-jsm-common.form-card.remove-form-confirmation.cancel-button',
		defaultMessage: 'Cancel',
		description:
			'Cancels confirmation dialog when user clicks on cancel button on the confirmation dialog when removing forms from request type configuration',
	},
	removeButton: {
		id: 'project-settings-product-features-jsm-common.form-card.remove-form-confirmation.remove-button',
		defaultMessage: 'Remove',
		description:
			'Acts as a confirm button when user clicks on remove button on the confirmation dialog when removing fomrs from request type confirmation.',
	},
});
